import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

type B3ModalElement = HTMLElement & { open?: boolean };

@Component({
  standalone: false,
  selector: 'app-register-confirmation-error-modal',
  templateUrl: './register-confirmation-error-modal.component.html',
  styleUrls: ['./register-confirmation-error-modal.component.scss'],
})
export class RegisterConfirmationErrorModalComponent {
  @ViewChild('errorModal') errorModal?: ElementRef<B3ModalElement>;

  @Input() open = false;
  @Input() message = 'Não foi possível concluir a operação. Tente novamente.';

  @Output() closed = new EventEmitter<void>();

  onDismiss(): void {
    this.closeModal();
  }

  onModalDismiss(): void {
    this.closeModal();
  }

  private closeModal(): void {
    const modalHost = this.errorModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });

    this.closed.emit();
  }
}
